// extracted by mini-css-extract-plugin
export var filterIncDec = "_dk-0";
export var leftBorder = "_dk-1";
export var rightBorder = "_dk-2";
export var stringInput = "_dk-3";